var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-navigation-drawer',{staticClass:"bottom-side-panel",class:{
    'bottom-side-panel--fullscreen': _vm.fullscreen,
  },attrs:{"bottom":"","app":"","temporary":"","tag":"aside"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('panel-header',{attrs:{"show":_vm.show},on:{"update:show":function($event){_vm.show=$event}}},[_vm._t("title")],2),_c('div',{staticClass:"bottom-side-panel__content-wrapper"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }